import { render, staticRenderFns } from "./SeccionFichas.vue?vue&type=template&id=6c1033f6&scoped=true"
import script from "./SeccionFichas.vue?vue&type=script&lang=js"
export * from "./SeccionFichas.vue?vue&type=script&lang=js"
import style0 from "./SeccionFichas.vue?vue&type=style&index=0&id=6c1033f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1033f6",
  null
  
)

export default component.exports